import { render, staticRenderFns } from "./UrlPathRenderer.vue?vue&type=template&id=5e3a820a&scoped=true&"
import script from "./UrlPathRenderer.vue?vue&type=script&lang=js&"
export * from "./UrlPathRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3a820a",
  null
  
)

export default component.exports